import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CommonFunctionService ,UserPOSData,UserMerchantData} from "./../../../services/Common/common-function.service";
import { InvoiceService } from "./../../../services/invoice/invoice.service";
import { Validators, FormControl } from "@angular/forms";
const swal = require('sweetalert');
import { SettingsService } from '../../../services/settings/settings.service';
import { environment } from '../../../../environments/environment';
import { BusinessInfoService } from '../../POSServices/Business/business-info.service';
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-business-info',
  templateUrl: './business-info.component.html',
  styleUrls: ['./business-info.component.scss']
})
export class BusinessInfoComponent implements OnInit {
  Flag = 0;
  Blogo: any;
  Bannerlogo: boolean = false;
  noBannerlogo: boolean = false;
  domainerror: boolean = false;
  customerWhatsappNumber: boolean = false;
  PCountry: any;
  PState: any;
  Pcity: any;
  IndustryType = new FormControl("", [Validators.required]);
  IndustrySubType = new FormControl("", [Validators.required]);
  Mobileerrormessage: any;
  mobileerror: boolean = true;
  slist: any;
  checkOnlineStore = new FormControl("", [Validators.required]);
  onlineStoreurl: boolean = false;
  posId: any;
  storeurl: boolean = false;
  temp = [];
  businessContactnum: any;
  Businessemail: any;
  defaultcountry = "India";
  defaultcurrence = "INR";
  defaulttimezone = "IST";

  Customercarewhatsapp = new FormControl('');
  public IndustryTsubtypelist: Array<string> = [''];

  public IndustryTypelist: Array<string> = ['Automobiles and Vehicles', 'Beauty and Wellness', 'Business Services', 'Cable and Broadband', 'Corporate Alliance', 'Education', 'Entertainment', 'Event Services', 'Food',
    'Government', 'Healthcare', 'Home Services', 'Housing', 'Individual Services', 'LFR and Brands', 'Logistics', 'Milk Dairy and Cooperative', 'NGO', 'Parking and Tolls', 'Personal Services',
    'Retail and Shopping', 'Transport', 'Travel', 'Tuition and Classes', 'Utilities', 'Wholesale Trade and B2B', 'IT Solution', 'Others'];
  // public states: Array<string> = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
  //   'Chhattisgarh', 'Dadra and Nagar Haveli', 'Daman and Diu', 'Delhi', 'Goa',
  //   'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Orissa', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana',
  //   'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  // ];
  public states: Array<string> = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jammu and Kashmir','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur',
  'Meghalaya', 'Mizoram','Nagaland','Odisha','Punjab','Rajasthan', 'Sikkim','Tamil Nadu','Telangana','Tripura', 'Uttar Pradesh',
  'Uttarakhand','West Bengal','Andaman and Nicobar','Chandigarh','Dadra and Nagar Haveli','Daman and Diu','Delhi','Lakshadweep',
  'Pondicherry',
  ];
  currency: any;
  isReadytoUpdatebusinesinfo: boolean = false;
  // file uplload
  fileSize: any;
  maxFileSize = 4194304;
  isFileHavingProperSize: boolean = false;
  whatsappEnable : boolean = false;
  whatsappNumber: boolean = false;

  ifnoBlogo: boolean = false;
  ifBlogo: boolean = false;
  imagecheck: any;
  maxWidth = 200;
  maxHeight = 200;
  myFiles: string[] = [];
  myBannerFiles: string[] = [];
  myFiles1 = [];
  BannerDetails: string[] = [];
  DateTime;
  isUploadFile: boolean = false;
  isfileValid: boolean = true;
  validFileExtensions;
  BGeoLocation:any;


  Type = new FormControl("", []);
  BusinesGeoLocation = new FormControl("", [Validators.required]);
  OnlineStoreDomainUrl = new FormControl("", [Validators.required, Validators.maxLength(25), Validators.pattern("^(?! )[a-zA-Z0-9.,;:<>()!@#$^&*?_]*$")]);
  OnlineStoreKey = new FormControl("", [Validators.required]);
  EnableOnlineStore = new FormControl("", [Validators.required]);
  OnlineStore: boolean = false;
  OnlineTemplate: boolean = false;
  Onlinestoreurl: any;
  isCopied: boolean = false;



  imageUrl: string = "/assets/img/default-image.png";
  businessviewinfo: boolean = false;
  MerchantKeyId: any;
  AuthenticationKey: any;
  SecureHashKey: any;
  EncryptionKey: any;
  TemplateType = [
    { text: "Fashion", value: "Fashion" },
    { text: "Education", value: "Education" },
    { text: "Store", value: "Store" },
    { text: "Diagnostic", value: "Diagnostic" },
  ];
  CurrencyType = [
    { text: "INR", value: "INR" },
    { text: "USD", value: "USD" },


  ];
  zone = [
    { text: "IST", value: "IST" },


  ];
  CountryNames = [
    { text: "Indian", value: "Indian" },


  ];
  isNewBusinessinfo: boolean = true;
  isUpdateBusinessinfo: boolean = false;
  merchantdata: UserPOSData;
  rows: any;
  Status = new FormControl("", [Validators.required]);
  PosSubscriptionId = new FormControl("", [Validators.required]);
  BusinessName = new FormControl("", [Validators.required]);
  OwnerName= new FormControl("", [Validators.required]);
  BusinessAddressLine1 = new FormControl("", [Validators.required]);
  BusinessAddressLine2 = new FormControl("", []);
  BusinessAddressLine3 = new FormControl("", []);
  City = new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  // State =new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  State = new FormControl("", [Validators.required, Validators.pattern("")]);
  //ZipCode   =new FormControl("", [ Validators.required, Validators.maxLength(6), Validators.pattern("^(?![a-zA-Z ])+[0-9]+((?![a-zA-Z@#$%^&*,()! ]).[0-9]{1,2})?$")]);

  ZipCode = new FormControl("", [Validators.required, Validators.pattern("^(?!000000)[0-9]{6}$")]);

  Country = new FormControl("", [Validators.required, Validators.maxLength(20), Validators.minLength(1), Validators.pattern("^(?! )[a-zA-Zs ]*$")]);
  Currency = new FormControl("", [Validators.required]);
  Localization = new FormControl("", []);
  // BusinessLogo   = new FormControl("", [Validators.required]);
  BusinessLogo: any;
  TimeZone = new FormControl("", []);
  PhoneNo = new FormControl("", [Validators.required, Validators.max(9999999999), Validators.min(1000000000), Validators.pattern("^(?! )[0-9]+?$")]);

  Email = new FormControl("", []);
  WebSite = new FormControl("", [Validators.pattern("(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?")]);
  CustomerContactEmail = new FormControl("", []);
  UpdateduserId = new FormControl("", [Validators.required]);
  UpdatedDateTime = new FormControl("", [Validators.required]);
  content: any;
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: BusinessInfoService,
    // private service: InvoiceService,
    private activatedRoute: ActivatedRoute,
    private services: SettingsService
  ) { }

  ngOnInit() { 
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getBusinessInfo();
    this.currency = this.commonfunction.GetCurrencysymbol();
    this.Businessemail = this.commonfunction.getEmail();
    let merchantdetails: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.businessContactnum = merchantdetails.ContactNo;
    this.slist = this.commonfunction.getStatesList();

    //let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();


  }
  getBusinessInfo() { 
    let form = { merchantKeyId: "", id: "", PosSubscriptionId: this.merchantdata.PosSubscriptionId };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      // form.PosSubscriptionId = this.commonfunction.getUserPOSData().PosSubscriptionId;

      console.log("formdata---" + form);
    });

    this.service.GetBusinessInfo(form).subscribe((result:any) => {
      if (result.PosSubscriptionId == form.PosSubscriptionId) {
        this.posId = result.PosSubscriptionId;
        this.isNewBusinessinfo = false;
        this.rows = result;
        if (this.rows.EnableOnlineStore == 1) {
          this.onlineStoreurl = true;
          this.OnlineTemplate = true;
        }
        else {
          this.onlineStoreurl = false;
          this.OnlineTemplate = false;
        }
        if(this.rows.EnableCustomerWhatsup == 1){
          this.customerWhatsappNumber = true;
          this.whatsappNumber = true;
        }
        else {
          this.customerWhatsappNumber = false;
          this.whatsappNumber = false;
        }
        this.PState = result.State;
        this.PCountry = result.Country;
        this.Pcity = result.City;
        this.BGeoLocation=result.BusinesGeoLocation
        this.SelectIndustrySubType();
        this.GetitemsList((data) => {
          // this.temp = _clone(data)
          // if(this.temp.length>0)
          // {
          //   if(result.onlineStoreTemplate !=null && this.onlineStoreurl==true)
          //   {

          //    this.Onlinestoreurl=environment.Onlinestoreurl+result.onlineStoreTemplate+";"+result.businessName+"?Id="+ result.posSubscriptionId;
          //   this.storeurl=true;
          //   }
          // }
        });
        this.businessviewinfo = true;
        this.content = result.BusinessLogoContent;
        if (this.content != null && this.content != "") {
          this.ifnoBlogo = false;
          this.ifBlogo = true;
          this.imagecheck = "Image Is Avaible";
          // alert(this.imagecheck);
        }
        else {
          this.ifnoBlogo = true;
          this.ifBlogo = false;
        }

        this.Blogo = result.merchantBannerContent;
        if (this.Blogo != null && this.Blogo != "" && this.Blogo != undefined) {
          this.Bannerlogo = true;
          this.noBannerlogo = false;
        }
        else {
          this.Bannerlogo = false;
          this.noBannerlogo = true;
        }

        // this.isUpdateBusinessinfo = false;
        // if(this.rows.EnableOnlineStore==1)
        // {
        //   this.onlineStoreKey=false;
        // }
        // else{
        //   form.EnableOnlineStore=0;
        // }

      } else {
        this.isUpdateBusinessinfo = false;
        this.isNewBusinessinfo = true;
        this.businessviewinfo = false;
      }
    });

  }

  Updatedetails() {
    this.isUpdateBusinessinfo = true;
    this.isNewBusinessinfo = false;
    this.businessviewinfo = false;

  }
  openConfirmationDialog() {

    swal({
      title: 'Business info Added Successfully',
      text: '',
      icon: 'success',
      buttons: {

        confirm: {
          text: 'Ok',
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        var length = +localStorage.getItem('orderlength')
        if (length > 0) {
          window.location.reload();
        }
        else {
          this.router.navigate(["/pos/setup"]);
        }
      }

    });

  }


  UpdateopenConfirmationDialog() {

    swal({
      title: 'Business info Updated Successfully',
      text: '',
      icon: 'success',
      buttons: {

        confirm: {
          text: 'Ok',
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        var length = +localStorage.getItem('orderlength')
        if (length > 0) {
          window.location.reload();
        }
        else {
          this.router.navigate(["/pos/setup"]);
        }
      }

    });

  }



  getFileDetails(e, value) {
    this.myFiles = [];
    //  this.validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"]; 
    this.isReadytoUpdatebusinesinfo = true;
    this.validFileExtensions = [".jpeg", ".jpg", ".png", ".bmp", ".doc", ".docx", ".pdf"];
    for (var i = 0; i < e.target.files.length; i++) {
      this.myFiles.push(e.target.files[i], value);
      this.Flag = 2;
      var sFileName = e.target.files[i].name;
      this.fileSize = e.target.files[i].size;
      if (sFileName.length > 0) {
        this.imagecheck = "Image is Updated"
        var blnValid = false;
        for (var j = 0; j < this.validFileExtensions.length; j++) {
          var sCurExtension = this.validFileExtensions[j];
          if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
            blnValid = true;
            this.isfileValid = true;
            break;
          }
        }

        if (!blnValid) {
          this.isfileValid = false;
          // alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + this.validFileExtensions.join(", "));
          return false;
        }
      }
    }
    if (this.myFiles.length != null) {
      this.isUploadFile = true;
    }
    else {
      this.isUploadFile = false;
    }
    if (this.fileSize < this.maxFileSize) {
      this.isFileHavingProperSize = false;
    }
    else {
      this.isFileHavingProperSize = true;
      {
        swal({

          title: 'uploaded file size is large',
          // text: 'Are you sure you want to delete?',
          icon: 'error',
          buttons: {
            confirm: {
              text: 'ok',
              value: true,
              visible: true,
              className: "bg-primary",
              closeModal: true
            }
          }

        }).then((isConfirm) => {
          if (isConfirm) {
            window.location.reload();
          } else {
            // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
          }
        });
        this.router.navigate(["/pos/businessinfo"]);
      }
    }

  }


  BannerFileDetails(e, value) {
    this.myBannerFiles = [];
    //  this.validFileExtensions = [".jpg", ".jpeg", ".bmp", ".gif", ".png"]; 
    this.isReadytoUpdatebusinesinfo = true;
    this.validFileExtensions = [".jpeg", ".jpg", ".png", ".bmp", ".doc", ".docx", ".pdf"];
    for (var i = 0; i < e.target.files.length; i++) {
      this.myBannerFiles.push(e.target.files[i], value);
      this.Flag = 1;
      var sFileName = e.target.files[i].name;
      this.fileSize = e.target.files[i].size;
      if (sFileName.length > 0) {
        this.imagecheck = "Image is Updated"
        var blnValid = false;
        for (var j = 0; j < this.validFileExtensions.length; j++) {
          var sCurExtension = this.validFileExtensions[j];
          if (sFileName.substr(sFileName.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
            blnValid = true;
            this.isfileValid = true;
            break;
          }
        }

        if (!blnValid) {
          this.isfileValid = false;
          // alert("Sorry, " + sFileName + " is invalid, allowed extensions are: " + this.validFileExtensions.join(", "));
          return false;
        }
      }
    }
    if (this.myBannerFiles.length != null) {
      this.isUploadFile = true;
    }
    else {
      this.isUploadFile = false;
    }
    if (this.fileSize < this.maxFileSize) {
      this.isFileHavingProperSize = false;
    }
    else {
      this.isFileHavingProperSize = true;
      {
        swal({

          title: 'uploaded file size is large',
          // text: 'Are you sure you want to delete?',
          icon: 'error',
          buttons: {
            confirm: {
              text: 'ok',
              value: true,
              visible: true,
              className: "bg-primary",
              closeModal: true
            }
          }

        }).then((isConfirm) => {
          if (isConfirm) {
            window.location.reload();
          } else {
            // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
          }
        });
        this.router.navigate(["/pos/businessinfo"]);
      }
    }

  }






  updateBusinessInfo() {
    let form = {
      PosSubscriptionId: "",
      BusinessName: "",
      BusinessAddressLine1: "",
      BusinessAddressLine2: "",
      BusinessAddressLine3: "",
      City: "",
      State: "",
      ZipCode: "",
      Country: "",
      Currency: "",
      Localization: "",
      BusinessLogo: "",
      TimeZone: "",
      PhoneNo: "",
      Email: "",
      WebSite: "",
      CustomerContactEmail: "",
      UpdateduserId: "",
      UpdatedDateTime: "",
      Status: "",
      BusinesGeoLocation: "",
      OnlineStoreDomainUrl: "",
      OnlineStoreKey: "",
      EnableOnlineStore: 0,
      OnlineStoreTemplate: "",
      BusinessLogoContent: "",
      IndustrySubType: "",
      IndustryType: "",
      BusinessOwnerName:"",
      EnableCustomerWhatsup:0,
      CustomerCareWhatsupNumber:""


    };

    var enablestore = this.onlineStoreurl;
    var enablewhatsapp = this.whatsappNumber;
    if (enablestore == true) {
      form.EnableOnlineStore = 1;
    }
    else {
      form.EnableOnlineStore = 0;
    }
    if(enablewhatsapp == true){
      form.EnableCustomerWhatsup = 1;
    }
    else {
      form.EnableCustomerWhatsup = 0;
    }
    form.BusinessOwnerName=this.OwnerName.value;
    form.IndustryType = this.IndustryType.value;
    form.IndustrySubType = this.IndustrySubType.value;
    form.OnlineStoreKey = this.OnlineStoreKey.value;
    form.OnlineStoreDomainUrl = this.OnlineStoreDomainUrl.value;
    form.BusinesGeoLocation = this.BGeoLocation;
    form.PosSubscriptionId = this.PosSubscriptionId.value;
    form.BusinessName = this.BusinessName.value;
    form.BusinessAddressLine1 = this.BusinessAddressLine1.value;
    form.BusinessAddressLine2 = this.BusinessAddressLine2.value;
    form.BusinessAddressLine3 = this.BusinessAddressLine3.value;
    form.City = this.City.value;
    form.State = this.State.value;
    form.ZipCode = this.ZipCode.value;
    form.Country = this.Country.value;
    form.Currency = this.Currency.value;
    form.Localization = this.Localization.value;
    // form.BusinessLogo= this.BusinessLogo.value;
    form.TimeZone = this.TimeZone.value;
    form.PhoneNo = this.PhoneNo.value;
    form.Email = this.Email.value;
    form.WebSite = this.WebSite.value;
    form.CustomerContactEmail = this.CustomerContactEmail.value;
    form.UpdateduserId = this.UpdateduserId.value;
    form.UpdatedDateTime = this.UpdatedDateTime.value;
    form.Status = this.Status.value;

    form.OnlineStoreTemplate = this.Type.value;
    form.CustomerCareWhatsupNumber = this.Customercarewhatsapp.value;



    form.PosSubscriptionId = this.merchantdata.PosSubscriptionId;
    // alert(this.requestDate.value);
    // alert(this.dueDate.value);
    var imageurl = this.BusinessLogo;
    if (imageurl == undefined || imageurl == "") {
      form.BusinessLogoContent = this.content;
    }

    const frmData = new FormData();
    if (this.myFiles.length > 0 && this.myBannerFiles.length > 0) {
      this.Flag = 3;
    }
    if (this.myFiles.length > 0) {
      frmData.append("fileUpload", this.myFiles[0]);
    }
    if (this.myBannerFiles.length > 0) {
      // this.Flag=1;
      frmData.append("fileUpload", this.myBannerFiles[0]);
      this.myFiles.push(this.myBannerFiles[0]);
    }

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.UpdateBusinessinfo(form).subscribe(result => {
      console.log("update result - ", result);
      if (result != null) {

        if (this.imagecheck == "Image is Updated") {
          this.service.InsertBusinessLogo(result.PosSubscriptionId, frmData, this.Flag).subscribe(result => {

          })
        }


        this.UpdateopenConfirmationDialog();
      }

    });
  }


  newBusinessInfo() {
    let form = {
      PosSubscriptionId: "",
      BusinessName: "",
      BusinessAddressLine1: "",
      BusinessAddressLine2: "",
      BusinessAddressLine3: "",
      City: "",
      State: "",
      ZipCode: "",
      Country: "",
      Currency: "",
      Localization: "",
      BusinessLogo: "",
      TimeZone: "",
      PhoneNo: "",
      Email: "",
      WebSite: "",
      CustomerContactEmail: "",
      UpdateduserId: "",
      UpdatedDateTime: "",
      Status: "",
      BusinesGeoLocation: "",
      OnlineStoreDomainUrl: "",
      OnlineStoreKey: "",
      EnableOnlineStore: 0,
      OnlineStoreTemplate: "",
      BusinessLogoContent: "",
      IndustryType: "",
      IndustrySubType: "",
      LoginUserId: '',
      BusinessOwnerName:"",
      EnableCustomerWhatsup:0,
      CustomerCareWhatsupNumber:""

    };
    var enablestore = this.OnlineStore;
    var enablewhatsapp = this.whatsappNumber;
    if (enablestore == true) {
      form.EnableOnlineStore = 1;
    }
    else {
      form.EnableOnlineStore = 0;
    }
    if(enablewhatsapp == true){
      form.EnableCustomerWhatsup = 1;
    }
    else {
      form.EnableCustomerWhatsup = 0;
    }
    form.BusinessOwnerName=this.OwnerName.value;
    form.OnlineStoreKey = this.OnlineStoreKey.value;
    form.OnlineStoreDomainUrl = this.OnlineStoreDomainUrl.value;
    form.BusinesGeoLocation = this.BGeoLocation;
    form.PosSubscriptionId = this.merchantdata.PosSubscriptionId;
    form.BusinessName = this.BusinessName.value;
    form.BusinessAddressLine1 = this.BusinessAddressLine1.value;
    form.BusinessAddressLine2 = this.BusinessAddressLine2.value;
    form.BusinessAddressLine3 = this.BusinessAddressLine3.value;
    form.City = this.City.value;
    form.State = this.State.value;
    form.ZipCode = this.ZipCode.value;
    form.Country = this.Country.value;
    form.Currency = this.Currency.value;
    form.Localization = this.Localization.value;
    // form.BusinessLogo= this.BusinessLogo.value;
    form.TimeZone = this.TimeZone.value;
    form.PhoneNo = this.PhoneNo.value;
    form.Email = this.Email.value;
    form.WebSite = this.WebSite.value;
    form.CustomerContactEmail = this.CustomerContactEmail.value;
    form.UpdateduserId = this.UpdateduserId.value;
    form.UpdatedDateTime = this.UpdatedDateTime.value;
    form.Status = this.Status.value;
    form.OnlineStoreTemplate = this.Type.value;
    form.IndustryType = this.IndustryType.value;
    form.IndustrySubType = this.IndustrySubType.value;
    form.CustomerCareWhatsupNumber = this.Customercarewhatsapp.value;
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    let merchantdetails: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    let posid = form.PosSubscriptionId
    const frmData = new FormData();
    // frmData.append("fileUpload", this.myFiles[0]);
    if (this.myFiles.length > 0 && this.myBannerFiles.length > 0) {
      this.Flag = 3;
    }
    if (this.myFiles.length > 0) {
      frmData.append("fileUpload", this.myFiles[0]);
    }
    if (this.myBannerFiles.length > 0) {
      frmData.append("fileUpload", this.myBannerFiles[0]);
      this.myFiles.push(this.myBannerFiles[0]);
    }
    this.service.AddBusinessUrl(form).subscribe(result => {
      console.log(" result - ", result);
      if (result != null) {
        this.service.InsertBusinessLogo(result.PosSubscriptionId, frmData, this.Flag).subscribe(result => {

        })
        this.GetAuthenticationDetails();
      }

    });
  }

  checkDomainurl() {
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    this.service.GetDomainurl(this.OnlineStoreDomainUrl.value, merchantdata.PosSubscriptionId).subscribe(result => {
      if (result != null) {
        this.domainerror = true;
      }
      else {
        this.domainerror = false;
      }
    })
  }
  copyToClipboard(element) {
    element.select();
    document.execCommand('copy');
    this.isCopied = true;
  }

  // newshowhide()
  // {

  //   if(this.checkOnlineStore.value ==false)
  //   {
  //     this.OnlineTemplate==false;
  //   }
  //   else{
  //     this.OnlineTemplate=true;
  //   }
  //   this.OnlineTemplate= !this.OnlineTemplate ;

  // }
  showhide() {
    this.OnlineStore = !this.onlineStoreurl;
    if (this.OnlineStore == false) {
      this.OnlineTemplate = false;
      this.onlineStoreurl = false;
    }
    else {
      this.OnlineTemplate = true;
      this.onlineStoreurl = true;
    }

  }
  GetAuthenticationDetails() {

    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    let merchantdetails: UserMerchantData = this.commonfunction.getUserMerchantData();

    let fTransaction = {
      MerchantKeyId: merchantdetails.MerchantKeyId,
      AuthenticationKey: "",
      AuthenticationToken: "",
      EncryptionKey: "",
      SecureHashKey: "",
      Status: "",
      Type: "",
      LoginUserId: ''
    }
    fTransaction.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
    this.services.GetAuthenticationDetails(fTransaction).subscribe(data => {
      if (data != null) {
        this.AuthenticationKey = data.AuthenticationKey;
        this.SecureHashKey = data.SecureHashKey;
        this.EncryptionKey = data.EncryptionKey;
        this.PayGPaymentGatewaySetups();
      }
    });


  }
  PayGPaymentGatewaySetups() {
    let merchantdata: UserPOSData = this.commonfunction.getUserPOSData();
    let merchantdetails: UserMerchantData = this.commonfunction.getUserMerchantData();
    let form = {
      AuthenticationKey: "",
      HashKey: "",
      EncryptionKey: "",
      MerchantKeyId: "",
      PosSubscriptionId: "",
    }
    form.AuthenticationKey = this.AuthenticationKey;
    form.HashKey = this.SecureHashKey;
    form.EncryptionKey = this.EncryptionKey;
    form.MerchantKeyId = merchantdetails.MerchantKeyId.toString();
    form.PosSubscriptionId = merchantdata.PosSubscriptionId;
    this.service.InsertPayGPaymentGatewaySetups(form).subscribe(data => {

    });

    this.openConfirmationDialog();

  }

  bussinessNameError() {
    return this.BusinessName.hasError("required") ? "BusinessName is required"
      : this.BusinessName.hasError("pattern") ? "BusinessName should be allow only alphabets" : "";
  }

  OwnerNameError()
  {
    return this.OwnerName.hasError("required") ? "Owner Name is required"
    : this.OwnerName.hasError("pattern") ? "Owner Name should be allow only alphabets" : "";
  }
  BusinessAddressLine1Error() {
    return this.BusinessAddressLine1.hasError("required") ? "BusinessAddressLine1 is required"
      : this.BusinessAddressLine1.hasError("pattern") ? "BusinessAddressLine1 should be allow only alphabets" : "";
  }
  //  BusinessAddressLine2Error() {
  //   return this.BusinessAddressLine2.hasError("required") ? "BusinessAddressLine2 is required"
  //     : this.BusinessAddressLine2.hasError("pattern") ? "BusinessAddressLine2 should be allow only alphabets" : "";
  //  }
  //  BusinessAddressLine3Error() {
  //   return this.BusinessAddressLine3.hasError("required") ? "BusinessAddressLine3 is required"
  //     : this.BusinessAddressLine3.hasError("pattern") ? "BusinessAddressLine3 should be allow only alphabets" : "";
  //  }
  cityNameError() {
    return this.City.hasError("required") ? "City Name is required"
      : this.City.hasError("pattern") ? "City Name should be alphabets only" : "";
  }
  //   stateNameError() {
  //    return this.State.hasError("required") ? "State Name is required"
  //     : this.State.hasError("pattern") ? "State Name should be allow only alphabets" : "";
  //  }  
  stateNameError() {
    return this.State.hasError("required")
      ? "State is required"
      : "";
  }

  zipcodeNameError() {
    return this.ZipCode.hasError("required") ? " Zip Code is required"
      : this.ZipCode.hasError("pattern") ? "Zip Code  should be 6 digit number only" : "";
  }

  countryNameError() {
    return this.Country.hasError("required") ? "Country  Name is required"
      : this.Country.hasError("pattern") ? "Country Name should be alphabets only" : "";
  }

  phoneerrors() {
    return this.PhoneNo.hasError("required") ? " Customer Care Phone Number  is required"
      : this.PhoneNo.hasError('min') || this.PhoneNo.hasError('max') ? 'Enter valid Contact Number (between 1000000000-9999999999)' :
        this.PhoneNo.hasError('pattern') ? 'Enter valid Contact number' : '';

    // : this.PhoneNo.hasError("pattern") ? "Phone Number should be allow only Numbers" : "";
  }
  Emailerrors() {
    return this.Email.hasError("required") ? "Email is required"
      : this.Email.hasError("pattern") ? "Email should be Enter Correct Format" : "";
  }
  customerEmailerrors() {
    return this.CustomerContactEmail.hasError("required") ? "Customer Care  ContactEmail is required"
      : this.CustomerContactEmail.hasError("pattern") ? "Customer Care ContactEmail should be Enter Correct Format" : "";
  }
  OnlineStoreDomainUrlerrors() {
    return this.OnlineStoreDomainUrl.hasError("required") ? "Online Store DomainUrl is required"
      : this.OnlineStoreDomainUrl.hasError("pattern") ? "Online Store DomainUrl should be Enter Correct Format" : "";

  }
  WebSiteerrors() {
    return this.WebSite.hasError("pattern") ? "Enter valid WebSite Url"

      : "";

  }
  Typeerrors() {
    return this.Type.hasError("required") ? " Online Store Template is required"
      : "";
  }
  onKey() {
    this.isReadytoUpdatebusinesinfo = true;
  }


  GetitemsList(cb) {


    this.service.GetItemListUrl(this.posId).subscribe(data => {
      if (data != null) {
        this.temp = _clone(data)
        if (this.temp.length > 0) {
          if (this.rows.OnlineStoreTemplate != null && this.onlineStoreurl == true && this.rows.OnlineStoreDomainUrl != null && this.rows.OnlineStoreTemplate != "" && this.rows.OnlineStoreDomainUrl != "") {

            this.Onlinestoreurl = environment.Onlinestoreurl + this.rows.OnlineStoreDomainUrl;
            this.storeurl = true;
          }
        }
      }

    });
    // const req = new XMLHttpRequest();
    // req.open('GET',environment.GetItemListUrl + "?PosSubscriptionId=" + this.posId);
    // req.onload = () => {
    //     cb(JSON.parse(req.response));

    //     };


    // req.send();
  }
  MobileValidation() {
    this.mobileerror = this.commonfunction.Mobilenumbervalidation(this.PhoneNo.value);
    if (this.mobileerror == true) {
      this.Mobileerrormessage = "Enter valid Mobile Number"
    }
    else {
      this.Mobileerrormessage = ""
    }
  }


  SelectIndustrySubType() {
    var subtypes = this.IndustryType.value;
    if (subtypes == "" || subtypes == undefined) {
      subtypes = this.rows.IndustryType;
    }
    if (subtypes == "Automobiles and Vehicles") {
      this.IndustryTsubtypelist = ['Auto Components', 'Four Wheeler', 'Heavy Vehicles', 'Second sales', 'Three Wheeler', 'Two Wheeler'];
    }
    if (subtypes == "Beauty and Wellness") {
      this.IndustryTsubtypelist = ['Nutraceuticals', 'Alternative therapies', 'Fitness and slimming'];
    }
    if (subtypes == "Business Services") {
      this.IndustryTsubtypelist = ['Social Services', 'Personal Services', 'Others'];
    }
    if (subtypes == "Cable and Broadband") {
      this.IndustryTsubtypelist = ['Digital Subscriber Line (DSL)', 'Cable Modem', 'Fiber', 'Wireless', 'Satellite', 'Broadband over Powerlines (BPL)'];
    }
    if (subtypes == "Corporate Alliance") {
      this.IndustryTsubtypelist = ['Joint Venture', 'Equity Strategic Alliance', 'Non-equity Strategic Alliance'];
    }
    if (subtypes == "Education") {
      this.IndustryTsubtypelist = ['Coaching & Skill Development', 'Education Consultancy', 'Education Supplies', 'Higher Education Institutes',
        'Online Education', 'Play School & Baby Sitting', 'Schools'];
    }
    if (subtypes == "Entertainment") {
      this.IndustryTsubtypelist = ['Advertising', 'Cinema', 'Digital Media', 'Gaming', 'Music', 'Printing & Publication', 'Television'];
    }

    if (subtypes == "Food") {

      this.IndustryTsubtypelist = ['Vegetables', 'Fruits', 'Grains', 'legumes', 'nuts and seeds', 'Fish and seafood', 'Dairy foods', 'Eggs'];
    }
    if (subtypes == "Government") {
      this.IndustryTsubtypelist = ['Tax Payments', 'Bail and Bond Payments', 'Postal Services', 'Government Services ( Not Elsewhere Classified)'];
    }

    if (subtypes == "Healthcare") {

      this.IndustryTsubtypelist = ['National Health Service', 'National Health Insurance', 'Social Health Insurance'];
    }
    if (subtypes == "Home Services") {
      this.IndustryTsubtypelist = ['Personal Care', 'Homemaking Services'];
    }
    if (subtypes == "Housing") {
      this.IndustryTsubtypelist = ['Commercial', 'Construction Materials', 'Housing', 'Land', 'Lift & Escalator'];
    }
    if (subtypes == "Individual Services") {
      this.IndustryTsubtypelist = ['Catering', 'Car Washes', 'Towing Services', 'Mobile shops', 'Furniture', 'Air Conditioning and Refrigeration Repair Shops'];
    }
    if (subtypes == "LFR and Brands") {
      this.IndustryTsubtypelist = ['LFR and Brands'];
    }
    if (subtypes == "Logistics") {
      this.IndustryTsubtypelist = ['Courier services Transportation Services'];
    }
    if (subtypes == "Milk Dairy and Cooperative") {
      this.IndustryTsubtypelist = ['Diary farms '];
    }
    if (subtypes == "NGO") {
      this.IndustryTsubtypelist = ['Community- Based Organisation', 'City Wide Organisation', 'Charitable and Social Service Organizations'];
    }
    if (subtypes == "Parking and Tolls") {
      this.IndustryTsubtypelist = ['Passenger Railways', 'Bus Lines', 'Local/Suburban Commuter Passenger Transportation', 'Trucking – Local/Long Distance',];
    }
    if (subtypes == "Personal Services") {
      this.IndustryTsubtypelist = ['Business Services', 'Personal Services'];
    }
    if (subtypes == "Retail and Shopping") {
      this.IndustryTsubtypelist = ['Retail and Shopping'];
    }
    if (subtypes == "Transport") {
      this.IndustryTsubtypelist = ['Transport'];
    }

    if (subtypes == "Tuition and Classes") {
      this.IndustryTsubtypelist = ['Tuition and Classes'];
    }
    if (subtypes == "Utilities") {
      this.IndustryTsubtypelist = ['Utilities'];
    }
    if (subtypes == "Wholesale Trade and B2B") {
      this.IndustryTsubtypelist = ['Wholesale Trade and B2B'];
    }
    if (subtypes == "IT Solution") {
      this.IndustryTsubtypelist = ['Software development', 'Direct Marketing'];
    }
    if (subtypes == "Event Services") {
      this.IndustryTsubtypelist = ['Wedding Party', 'Personal Events', 'Organizational Events'];
    }
    if (subtypes == "Travel") {
      this.IndustryTsubtypelist = ['Travel Agencies and Tour Operations'];
    }

    if (subtypes == "Others") {
      this.IndustryTsubtypelist = ['Others'];
    }
  }

  Getzipcodedetails() {
    this.service.Zipcodedetails(this.ZipCode.value).subscribe(result => {
      if (result != null) {
        this.Pcity = result.CityVillageArea;
        this.PState = result.State;
        var pincode = this.PState.toLowerCase().split(' ');
        for (var i = 0; i < pincode.length; i++) {
          pincode[i] = pincode[i].charAt(0).toUpperCase() + pincode[i].substring(1);
        }
        this.PState = pincode.join(' ');
        this.PCountry = result.Country;
      }
      else {
        this.Pcity = "";
        this.PState = "";
        this.PCountry = "";
      }
    });
  }

  enableWhatsapp() {
    this.whatsappEnable = !this.customerWhatsappNumber;
    if (this.whatsappEnable == false) {
      this.whatsappNumber = false;
      this.customerWhatsappNumber = false;
    }
    else {
      this.whatsappNumber = true;
      this.customerWhatsappNumber = true;
    }

  }
}
